import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { AccessTeamDTO } from '../../../api/access-team-api';
import { AccessTeamUserDTO } from '../../../api/access-team-user-api';
import { UserDTO } from '../../../api/user-api';
import SvgClose from '../../../assets/icons/Close';
import SvgDelete from '../../../assets/icons/Delete';
import SvgSave from '../../../assets/icons/Save';
import { BasicModal } from '../../../components/basic/basic-modal';
import { T } from '../../../components/basic/text';
import { yup } from '../../../components/basic/yup';
import { FormikTextField } from '../../../components/formik';

interface SaveAccessTeamUserModalProps {
    show: boolean;
    allowEdit: boolean;
    selectedAccessTeamUser?: AccessTeamUserDTO;
    accessTeams: AccessTeamDTO[];
    users: UserDTO[];
    onHide: () => void;
    onSave: (values: AccessTeamUserDTO) => void;
    onDelete?: (accessTeamUser: AccessTeamUserDTO) => void;
}

export function SaveAccessTeamUserModal({
    show,
    allowEdit,
    selectedAccessTeamUser,
    accessTeams,
    users,
    onHide,
    onSave,
    onDelete,
}: SaveAccessTeamUserModalProps) {
    const AccessTeamUserSchema = yup.object().shape({
        accessTeamSerial: yup.number().required(' '),
        userName: yup.string().required(' '),
    });

    const defaultValues: AccessTeamUserDTO = {
        accessTeamSerial: selectedAccessTeamUser ? selectedAccessTeamUser.accessTeamSerial : 0,
        userName: selectedAccessTeamUser ? selectedAccessTeamUser.userName : '',
    };

    if (!show) return <></>;

    return (
        <Formik
            initialValues={defaultValues}
            validationSchema={AccessTeamUserSchema}
            onSubmit={onSave}
        >
            {formik => (
                <BasicModal
                    show={show}
                    onHide={onHide}
                    size="xl"
                    title={
                        <bd.Flex className="w-100" align="center" content="between">
                            <T>
                                {selectedAccessTeamUser
                                    ? 'edit-access-team-user'
                                    : 'new-access-team-user'}
                            </T>
                            <bd.Flex align="center" gap={2}>
                                <bd.Button
                                    variant="icon"
                                    size="sm"
                                    onClick={formik.submitForm}
                                    disabled={!allowEdit}
                                >
                                    <SvgSave />
                                </bd.Button>
                                {selectedAccessTeamUser && onDelete && (
                                    <bd.Button
                                        disabled={!allowEdit}
                                        variant="icon"
                                        color="secondary"
                                        size="sm"
                                        onClick={() => onDelete(selectedAccessTeamUser)}
                                    >
                                        <SvgDelete />
                                    </bd.Button>
                                )}
                                <bd.Button
                                    variant="icon"
                                    color="secondary"
                                    size="sm"
                                    onClick={onHide}
                                >
                                    <SvgClose />
                                </bd.Button>
                            </bd.Flex>
                        </bd.Flex>
                    }
                >
                    <Form>
                        <bd.Flex align="center" wrap>
                            <FormikTextField
                                label="access-team-serial"
                                name="accessTeamSerial"
                                readOnly={!allowEdit || !!selectedAccessTeamUser}
                                type="select"
                                items={[
                                    { id: null, title: '' },
                                    ...accessTeams.map(accessTeam => ({
                                        id: accessTeam.serial,
                                        title: `${accessTeam.title} `,
                                    })),
                                ]}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="user-name"
                                name="userName"
                                readOnly={!allowEdit || !!selectedAccessTeamUser}
                                type="select"
                                items={[
                                    { id: null, title: '' },
                                    ...users.map(user => ({
                                        id: user.userName,
                                        title: `${user.firstName} ${user.lastName} `,
                                    })),
                                ]}
                                width="11rem"
                                handleEnter
                            />
                        </bd.Flex>
                    </Form>
                </BasicModal>
            )}
        </Formik>
    );
}
